import z from "zod"

export const GetInstagram = z.object({
  "hub.mode": z.string(),
  "hub.verify_token": z.string(),
  "hub.challenge": z.string(),
})

const InstagramWebhookMessageBase = z.object({
  sender: z.object({
    id: z.string(),
  }),
  recipient: z.object({
    id: z.string(),
  }),
  timestamp: z.number().transform((e) => new Date(e)),
})

export const InstagramWebhookAttachmentEnum = {
  image: "image",
  audio: "audio",
  video: "video",
  file: "file",
  story_mention: "story_mention",
  share: "share",
  ig_post: "ig_post",
  ig_reel: "ig_reel",
  ig_story: "ig_story",
  ephemeral: "ephemeral",
  unsupported_type: "unsupported_type",
  template: "template",
} as const

export const InstagramWebhookMessagesBodySchema = z.object({
  ...InstagramWebhookMessageBase.shape,
  message: z
    .object({
      mid: z.string(),
      text: z.string().nullish(),
      is_echo: z.boolean().optional(),
      is_deleted: z.boolean().optional(),
      reply_to: z
        .union([
          z.object({
            mid: z.string(),
            is_self_reply: z.boolean().optional(),
          }),
          z.object({
            story: z.object({
              url: z.string(),
              id: z.string(),
            }),
          }),
        ])
        .optional(),
      attachments: z
        .array(
          z.object({
            type: z.nativeEnum(InstagramWebhookAttachmentEnum),
            payload: z
              .object({
                url: z.string().optional(),
                title: z.string().optional(),
                reel_video_id: z.string().optional(),
                story_media_id: z.string().optional(),
                story_media_url: z.string().optional(),
              })
              .optional(),
          }),
        )
        .nullish(),
    })
    .optional(),
  read: z.object({ mid: z.string() }).optional(),
})

const InstagramWebhookMessageReactionSchema = z.object({
  ...InstagramWebhookMessageBase.shape,
  reaction: z.object({
    mid: z.string(),
    action: z.string(),
    reaction: z.string(),
    emoji: z.string(),
  }),
})

export const InstagramWebhookCommentSchema = z.object({
  field: z.literal("comments"),
  value: z.object({
    from: z.object({
      id: z.string(),
      username: z.string(),
    }),
    media: z.object({
      id: z.string(),
      media_product_type: z.enum(["FEED", "STORY", "REELS", "AD"]),
    }),
    text: z.string().optional(),
    id: z.string(),
  }),
})

export const InstagramWebhookSchema = z.object({
  object: z.string(),
  entry: z.array(
    z.union([
      z.object({
        id: z.string(),
        messaging: z.array(InstagramWebhookMessagesBodySchema),
      }),
      z.object({
        id: z.string(),
        messaging: z.array(InstagramWebhookMessageReactionSchema),
      }),
      z.object({
        id: z.string(),
        changes: z.array(InstagramWebhookCommentSchema),
      }),
    ]),
  ),
})
